<!--高级模板-新增高级版模板-->
<!--更新contractinfo信息的时候尽量选在点击下一步时-->
<template>
  <div class="wrap">
    <!--    第一步-->
    <el-form
      size="small"
      ref="contForm"
      :model="contractInfo"
      class="cont-form"
    >
      <div class="f-top">
        <el-form-item>
          <h4><i></i>模板名称</h4>
        </el-form-item>
        <el-form-item prop="tplName" :rules="myRules.tplName" class="s-er">
          <el-row style="width: 550px;">
            <el-input
              v-model="contractInfo.tplName"
              placeholder="请输入模板名称"
              @blur="validContractName"
            />
          </el-row>
        </el-form-item>
      </div>

      <div class="f-top">
        <el-form-item>
          <h4><i></i>模板文件</h4>
        </el-form-item>
        <el-form-item>
          <div class="input-wrap">
            <!--合同-->
            <div class="input-box">
              <!--未上传-->
              <template v-if="!contractFile.fileName">
                <span class="el-icon-plus"></span><br />
                <p>上传docx/doc/pdf格式文件</p>
              </template>
              <!--上传后展示-->
              <template v-else>
                <!--fileSuffix-->
                <div class="f-box">
                  <div class="bx">
                    <img
                      v-if="fileSuffix(contractFile.fileName) === 'pdf'"
                      src="/images/advancedVersion/pdf.png"
                    />
                    <img
                      v-if="
                        fileSuffix(contractFile.fileName) === 'doc' ||
                          fileSuffix(contractFile.fileName) === 'docx'
                      "
                      src="/images/advancedVersion/word.png"
                    />
                    <!--蒙层-->
                    <div class="msk"><a @click="reUpload">重新上传</a></div>
                  </div>
                  <p :title="contractFile.fileName">
                    {{ contractFile.fileName }}
                  </p>
                </div>
              </template>
              <input
                @change="contractFileUpload"
                type="file"
                ref="contractFileInput"
              />
            </div>
            <!--附件-->
            <div class="fj-wrap">
              <span class="fj-box">
                <span
                  class="icon-fj"
                  style="vertical-align: text-bottom;"
                ></span
                >添加附属材料（{{ enclosureFiles.length }}/3)
                <input
                  @change="handleAttatchFileUpload"
                  type="file"
                  ref="attatchFileInput"
                />
              </span>

              <el-tooltip effect="light" placement="bottom-start">
                <div slot="content">
                  支持任意格式文件；<br />最多可添加3个附件，每个最大30M；<br />为固定附属材料，模板使用人可添加，不可删除<br />仅供参与方查阅，不用于签署
                </div>
                <i
                  class="el-icon-question"
                  style="font-size: 16px;margin-left: 10px;color: #a1a1a1;cursor: pointer;margin-right: 50px;"
                ></i>
              </el-tooltip>

              <template v-if="enclosureFiles && enclosureFiles.length">
                <template v-for="(item, index) in enclosureFiles">
                  <span class="fj" :key="index">
                    <span class="text">{{ item.fileName }}</span>
                    <!--<span class="size">{{Math.ceil(item.size/1024)}}KB</span>-->
                    <span
                      class="el-icon-error"
                      @click="delAttatch(item, index)"
                    ></span>
                  </span>
                </template>
              </template>
            </div>
          </div>
        </el-form-item>
      </div>

      <div class="f-center">
        <el-form-item>
          <div class="h4">
            <i></i>签署设置
            <div class="wp">
              <div class="radio">
                <div>
                  <div ref="step5">
                    <el-checkbox v-model="contractInfo.orderFlag"
                      ><b>按顺序签名</b>
                      <small>/各方按顺序完成签署</small>
                    </el-checkbox>
                  </div>
                </div>
                <el-button
                  class="abtn"
                  style="margin-right: 20px;margin-top: -10px;"
                  @click="addSignerList()"
                  type="danger"
                  >添加签署方
                </el-button>
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="tab">
            <div v-if="signers && signers.length" class="list-box">
              <draggable
                :list="signers"
                @start="dragging = true"
                @end="dragging = false"
                :options="{
                  handle: '.icon-move_box',
                  animation: 200,
                  ghostClass: 'ghost'
                }"
                :move="
                  () => {
                    return this.contractInfo.orderFlag;
                  }
                "
              >
                <transition-group type="transition">
                  <template v-for="(item, i) in signers">
                    <!-- 正常签署方 -->
                    <li :key="i">
                      <el-form
                        :model="item"
                        size="small"
                        ref="contractListTab"
                        :key="i"
                        :data-signerAbc="item.signerAbc"
                        class="contract-lit__tab"
                      >
                        <div
                          :class="{
                            item: true,
                            'sign-item': true,
                            'i-drag': contractInfo.orderFlag
                          }"
                        >
                          <div
                            v-show="contractInfo.orderFlag"
                            class="icon-move_box"
                          >
                            <i></i>
                          </div>
                          <div
                            v-show="contractInfo.orderFlag"
                            style="width: 10px;text-align: right;"
                          >
                            <!--{{i+1}}-->
                          </div>
                          <div class="user-type">
                            <p>{{ item.signerAbc }}</p>
                          </div>
                          <div class="col" style="width: 135px;">
                            <el-form-item>
                              <el-select
                                @change="
                                  val => {
                                    handleFixType(val, i);
                                  }
                                "
                                :value="item.fix"
                                size="small"
                                class="select"
                              >
                                <el-option :value="1" label="固定人员" />
                                <el-option :value="0" label="模板发起人指定" />
                              </el-select>
                            </el-form-item>
                          </div>
                          <template v-if="!!item.fix">
                            <div
                              style="display: flex;justify-content: flex-start;flex: 1;"
                            >
                              <div class="col" style="width:230px;">
                                <el-form-item
                                  prop="emailOrMobile"
                                  :rules="rulesTab.emailOrMobile"
                                >
                                  <el-input
                                    @blur="
                                      () => {
                                        (item.emailOrMobile = $utils.trim(
                                          item.emailOrMobile
                                        )),
                                          getUserInfoBySelectTargetId(
                                            item.emailOrMobile,
                                            i
                                          );
                                      }
                                    "
                                    v-model="item.emailOrMobile"
                                    placeholder="签署方接收手机/邮箱"
                                  >
                                    <i
                                      class="icon icon-btn_tels"
                                      style="background-size: contain;cursor: pointer"
                                      slot="suffix"
                                      @click="handleTelsClickOther(item, i)"
                                    ></i>
                                  </el-input>
                                </el-form-item>
                              </div>

                              <div class="col" style="width:230px;">
                                <!-- 下拉选择框 -->
                                <template
                                  v-if="
                                    item.canSelectArray &&
                                      item.canSelectArray.length > 1
                                  "
                                >
                                  <el-form-item>
                                    <el-select
                                      @change="
                                        handleSelectCorpAccount($event, item)
                                      "
                                      v-model="item.canSelectArrayIndex"
                                      size="small"
                                      class="select"
                                      style="width: 100%"
                                    >
                                      <el-option
                                        :value="vi"
                                        :label="v.name"
                                        v-for="(v, vi) in item.canSelectArray"
                                        :key="vi"
                                      />
                                    </el-select>
                                  </el-form-item>
                                </template>
                                <template v-else>
                                  <el-form-item
                                    prop="name"
                                    :rules="rulesTab.name"
                                    :show-message="item.disabled !== 'disabled'"
                                  >
                                    <el-input
                                      :value="item.name"
                                      @input="
                                        val => {
                                          item.name = val;
                                        }
                                      "
                                      :disabled="item.disabled === 'disabled'"
                                      placeholder="请输入签署方名称"
                                    />
                                  </el-form-item>
                                </template>
                              </div>
                              <div class="col" style="width: 70px;">
                                <el-form-item>
                                  <el-select
                                    @change="handleSignUserType(item)"
                                    v-model="item.userType"
                                    :disabled="item.disabled === 'disabled'"
                                    size="small"
                                    class="select"
                                  >
                                    <el-option :value="0" label="个人" />
                                    <el-option :value="1" label="企业" />
                                  </el-select>
                                </el-form-item>
                              </div>

                              <!-- 身份证 和 营业执照号 -->
                              <div
                                v-if="item.userType === 0"
                                class="col"
                                style="width: 160px;"
                              >
                                <!-- 身份证 -->
                                <el-form-item
                                  class="IDCard"
                                  v-if="item.userType === 0"
                                  prop="identityNo"
                                  :rules="
                                    item.disabled !== 'disabled'
                                      ? rulesTab.IDCard
                                      : {}
                                  "
                                  :show-message="item.disabled !== 'disabled'"
                                  style="position: relative;"
                                >
                                  <el-input
                                    v-model="item.identityNo"
                                    :disabled="item.disabled === 'disabled'"
                                    :class="{
                                      'no-padding': item.disabled ? true : false
                                    }"
                                    placeholder="请输入中国大陆18位身份证号码"
                                  />
                                  <a
                                    @click="handleTargetIdChange(item)"
                                    v-if="item.ischange === 1"
                                    href="javascript:void (0)"
                                    class="color-success amend-signator amend-tab__form"
                                    >修改</a
                                  >
                                </el-form-item>
                              </div>
                            </div>
                          </template>
                          <template v-if="!item.fix">
                            <div
                              class="col"
                              style="flex: 1;color: rgba(41, 2, 2, 0.45);font-size: 14px;"
                            >
                              <img
                                style="width: 8px;height:8px;margin-right:3px;vertical-align: middle;"
                                src="../../../assets/images/x-icon.png"
                              />使用模板时，由模板发起人指定签署方
                            </div>
                          </template>

                          <div class="col final">
                            <el-form-item>
                              <el-checkbox
                                v-model="item.authLevel"
                                :true-label="11"
                                style="margin: 0;"
                                :false-label="null"
                                @change="authLevelChange(i)"
                              >
                                需要人脸识别
                              </el-checkbox>
                              <el-tooltip
                                effect="light"
                                content=""
                                placement="bottom-end"
                              >
                                <div slot="content">
                                  选择人脸识别，可把签署方的<br />人脸视频文件作为签署证据
                                </div>
                                <i
                                  class="el-icon-question"
                                  style="font-size: 16px;color: #a1a1a1;cursor: pointer"
                                ></i>
                              </el-tooltip>
                              <span
                                class="el-icon-delete"
                                @click="delSigner(item, i)"
                                v-if="signers.length > 1"
                              ></span>
                            </el-form-item>
                          </div>
                        </div>
                      </el-form>
                    </li>
                  </template>
                </transition-group>
              </draggable>
            </div>
            <el-dialog title="提示" :visible.sync="authLevelShow" width="20%">
              <span style="display: inline-block;text-align: center"
                >是否取消该签署方的人脸识别？取消人脸识别，将不能把该签署方的人脸视频文件作为签署证据。</span
              >
              <span slot="footer" class="dialog-footer">
                <el-button @click="authLevelShow = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false"
                  >确 定</el-button
                >
              </span>
            </el-dialog>
          </div>
        </el-form-item>
      </div>
      <!-- 1197 隐藏其他设置（22/12/28） -->
      <!-- <div class="f-top">
        <el-form-item>
          <h4><i></i>其他设置</h4>
        </el-form-item>
        <el-form-item>
          <div class="row-con">
            <span style="line-height: 37px;">模板授权范围</span>
            <div class="my-select" @click="setTreeCheckedNodes">
              <span v-if="!selectNodes.length">请选择</span>
              <template v-else>
                <span
                  class="tx"
                  v-for="(item, index) in selectNodes"
                  :key="index"
                  :title="item.groupName"
                  >{{ item.groupName
                  }}<span
                    class="el-icon-error"
                    @click.stop="delNode(item)"
                  ></span
                ></span>
              </template>

              <span class="el-icon-arrow-down"></span>
            </div>
          </div>
        </el-form-item>
      </div> -->

      <el-form-item class="text-center">
        <!--<el-button class="abtn" @click="saveToDraft" type="danger" v-if="!$route.query.id">存为草稿</el-button>-->
        <el-button class="abtn" @click="nextStep" type="danger"
          >下一步</el-button
        >
      </el-form-item>
    </el-form>
    <!--    第二步-->

    <!--    弹窗-->
    <!--通讯簿列表-->
    <el-dialog
      title="选择签署方"
      :visible.sync="showTel"
      lock-scroll
      width="749px"
    >
      <!-- tabs -->
      <el-tabs v-model="activeTabSigner">
        <!-- 我的通讯录 -->
        <el-tab-pane label="常用签署方" name="default">
          <el-row class="tel-search">
            <el-col :span="6">
              <el-input
                v-model="telPageInfo.accountNo"
                @keyup.enter.native="getTelList()"
                size="small"
                placeholder="邮箱/手机号"
              />
            </el-col>
            <el-col :span="6" :offset="1">
              <el-input
                v-model="telPageInfo.name"
                @keyup.enter.native="getTelList()"
                size="small"
                placeholder="签署方姓名"
              />
            </el-col>
            <el-col :span="6" :offset="1">
              <el-input
                v-model="telPageInfo.idNo"
                @keyup.enter.native="getTelList()"
                size="small"
                placeholder="证件号"
              />
            </el-col>
            <el-col :span="3" :offset="1">
              <el-button @click="getTelList" size="small" class="btn"
                >查询</el-button
              >
            </el-col>
          </el-row>
          <div
            class="tel-box"
            style="max-height: 340px;overflow: auto; min-width: 749px"
          >
            <el-table
              @row-click="handleTelRowClickSelectRow"
              :data="telList"
              style="width: 100%"
              highlight-current-row
              tooltip-effect="dark"
              stripe
              :cell-style="{ cursor: 'pointer' }"
              :header-cell-style="{
                background: '#f9f9f9',
                color: '#333333',
                fontWeight: '500'
              }"
            >
              <el-table-column label="签署方名称" prop="enterpriseName" />
              <el-table-column label="证件号" prop="businessLicense" />
              <el-table-column label="邮箱/手机号" prop="mobileOrChild" />
            </el-table>
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="telPageInfo.itemPage"
            :page-sizes="[6, 12, 30, 60]"
            :page-size="telPageInfo.pageSize"
            layout="sizes, prev, pager, next, jumper, total"
            :total="telPageInfo.total"
            style="text-align: right;margin-top: 10px"
          />
        </el-tab-pane>
        <!-- 我的组织 -->
        <el-tab-pane
          v-if="isGroup"
          :label="activeTabOrganizationName"
          name="organization"
        >
          <el-row class="tel-search">
            <el-col :span="18">
              <el-row>
                <el-col :span="8" style="padding: 0 20px 0 0">
                  <el-input
                    clearable
                    v-model="myCorpModel.keyword"
                    @keyup.enter.native="clickHandleMyCorpSearch()"
                    size="small"
                    placeholder="邮箱/手机号"
                  />
                </el-col>
                <el-col :span="8" style="padding: 0 10px">
                  <el-input
                    clearable
                    v-model="myCorpModel.corpUserName"
                    size="small"
                    placeholder="签署方名称"
                  />
                </el-col>
                <el-col :span="8" style="padding: 0 10px">
                  <el-select
                    v-model="myCorpModel.corpGroupId"
                    placeholder="请选择部门"
                    size="small"
                  >
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="(item, i) in department"
                      :key="i"
                      :label="item.groupName"
                      :value="item.corpGroupId"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="5" :offset="1">
              <el-button
                @click="clickHandleMyCorpSearch()"
                size="small"
                class="btn"
                >查询</el-button
              >
            </el-col>
          </el-row>
          <div class="tel-box" style="height: 415px;overflow: auto;">
            <el-table
              v-loading="myCorpModel.loading"
              :empty-text="myCorpModel.emptyText"
              @row-click="handleRowClickMyCorp"
              :data="tableListMyCorp"
              style="width: 100%"
              highlight-current-row
              tooltip-effect="dark"
              stripe
              :cell-style="{ cursor: 'pointer' }"
              :header-cell-style="{
                background: '#f9f9f9',
                color: '#333333',
                fontWeight: '500'
              }"
            >
              <el-table-column label="邮箱/手机号" prop="targetId" />
              <el-table-column label="签署方名称" prop="userName" />
              <el-table-column label="部门" prop="groupNames" />
            </el-table>
          </div>
          <br />
          <el-pagination
            @size-change="handleSizeChangeQueryToolMyCorp"
            @current-change="handleCurrentChangeQueryToolMyCorp"
            :current-page="myCorpModel.itemPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="myCorpModel.pageSize"
            layout="sizes, prev, pager, next, jumper, total"
            :total="myCorpModel.total"
            style="text-align: right;"
          />
        </el-tab-pane>
      </el-tabs>
      <p slot="footer" class="dialog-footer">
        <el-button
          @click="handleClickSelectSignorOk()"
          type="danger"
          size="small"
          class="btn"
          >确定</el-button
        >
      </p>
    </el-dialog>

    <!--    模板授权范围-->
    <el-dialog
      title="模板授权范围"
      :visible.sync="visibleMoveOrg"
      top="25vh"
      width="50%"
    >
      <el-tree
        ref="referenceMoveTree"
        class="tree-style"
        :data="treeGroupCopy"
        check-on-click-node
        :expand-on-click-node="false"
        :check-strictly="true"
        node-key="corpGroupId"
        :props="defaultProps"
        show-checkbox
        default-expand-all
      ></el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="visibleMoveOrg = false">取 消</el-button>
        <el-button size="mini" type="primary" @click="getCheckedNodes()"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!--1.填写企业证件号，2.对填写的姓名身份证号进行二要素验证错误-->
    <sign-info-tips-dialog
      :show.sync="visibleCredit"
      :entCreditArr="entCreditArr"
      :entCreditJson="entCreditJson"
      :userIdentityInfoArr="userIdentityInfoArr"
      @continue="addContractById"
      @cancel="handleDelSendContract"
      sureText="确认无误"
    />

    <!--确认退出弹窗-->
    <el-dialog
      title="提示"
      class="com-myDialog"
      :visible.sync="tipsDialogVisible"
      :close-on-click-modal="false"
    >
      <div class="con">
        <p style="margin-top: 40px;">
          <span class="el-icon-warning"></span>当前内容还未保存，确认退出编辑？
        </p>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="(tipsDialogVisible = false), (sureEdit = false)"
          >继续填写</el-button
        >
        <el-button type="primary" @click="confirmEdit">仍然退出</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import md5 from "js-md5";
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import draggable from "vuedraggable";
import ContractView from "../../../components/contract-view/index";
import ToolTip from "../../../components/tool-tip/index";
import SingerForm from "../../../components/singer-form/index";
import Flow from "../../../components/flow/index";
import SignInfoTipsDialog from "../../../components/contract/signInfoTipsDialog";
import {
  configUrl,
  postFileTempUpload2,
  postFindByEmailOrMphon,
  postTelFindByPagedEnterpriseList,
  uploadFileAndConvertInfo,
  ApiMethods,
  queryCreditCodeByEntName,
  queryUserValidateByNameIDnum
} from "../../../assets/js/http-serve/http-methods";
import {
  businessVal,
  identityNo,
  mobileOrEmail,
  personalName
} from "../../../assets/js/lib/valid-methods";

import { ApiCorpMethods } from "@/assets/js/http-serve/corp/http-methods";
import Vue from "vue";
import { formatParam } from "../../advancedVersion/advancedVersion";

function getStore() {
  return Vue.prototype.$storeInstance;
}

const signerDataList = [
  { signerAbc: "签署方一" },
  { signerAbc: "签署方二" },
  { signerAbc: "签署方三" },
  { signerAbc: "签署方四" },
  { signerAbc: "签署方五" },
  { signerAbc: "签署方六" },
  { signerAbc: "签署方七" },
  { signerAbc: "签署方八" },
  { signerAbc: "签署方九" },
  { signerAbc: "签署方十" }
];

export default {
  name: "advancedVersionAddTpl",
  components: {
    ContractView,
    ToolTip,
    SingerForm,
    draggable,
    Flow,
    SignInfoTipsDialog
  },
  data() {
    return {
      loading: null,
      // step: 'step1',
      // 第一步
      // 授权授权范围
      defaultProps: {
        children: "childCorpGroups",
        label: "label"
      },
      visibleMoveOrg: false,
      treeGroupCopy: [],
      selectNodes: [], // 选中的节点
      // 。。。。。。。常用签署方 start 。。。。。。。
      // 是否是集团账户
      isGroup: false,
      showTel: false,
      telList: [],
      telPageInfo: {
        itemPage: 1,
        pageSize: 6,
        total: 0,
        name: null,
        idNo: null,
        accountNo: null
      },
      // 签署方 tabs
      activeTabSigner: "default", // 我的通讯录 default , 我的组织 organization
      activeTabOrganizationName: "我的组织",
      tableSignorSelectRow: undefined,
      tableSignorSelectRowTargetID: undefined,
      // 我的组织 选择签署人
      myCorpModel: {
        loading: false,
        emptyText: "请输入组织内部签署方名称或账号",
        keyword: "",
        itemPage: 0,
        pageSize: 10,
        total: 0,
        corpUserName: "", // 签署方名称
        corpGroupId: "" // 部门ID
      },
      tableListMyCorp: [],
      selectIndex: 0,
      // 。。。。。。。常用签署方 end 。。。。。。。
      // 合同信息
      contractInfo: {
        tplId: null,
        tplName: "",
        signers: [], // 签署方
        files: [], // 文件上传信息
        orderFlag: false, // 是否顺序签字
        inputGroups: [{ title: "", inputs: [] }], // 组件列表
        groupIdSet: [] // 授权多个部门 id
      },
      authLevelShow: false,
      myRules: {
        tplName: [
          { max: 100, message: "模板名称不能超过100个字符", trigger: "change" },
          { required: true, message: "请输入模板名称", trigger: "change" }
        ]
      },
      rulesTab: {
        emailOrMobile: [{ validator: mobileOrEmail, trigger: "change" }],
        signatoryMobile: [{ validator: mobileOrEmail, trigger: "change" }],
        corpUser: [{ validator: mobileOrEmail, trigger: "change" }],
        name: [{ validator: personalName, trigger: "blur" }],
        // signatoryIdentityCard: [{validator: identityNo, trigger: 'blur'}]
        IDCard: [{ validator: identityNo, trigger: "blur" }],
        BusinessLicenseNo: [{ validator: businessVal, trigger: "blur" }]
      },
      // 上传文件
      contractFile: {}, // 上传的合同文件
      enclosureFiles: [], // 上传的附件
      /**
         * // 后端需要变量
         "authLevel": null, // 验证等极
         "emailOrMobile": "", // 手机或邮箱
         "fix": fix, // "是否固定人员1是，0不是"
         "identityNo": "", // 证件号
         "name": "", // 名称
         "signLevel": 0, // 签章等级
         "signerAbc": signerDataList[this.signers.length].signerAbc, // 签署人abc标识
         "userType": 0, // 用户类型
         corpUser: false, // 如果是集团账户 存 corpUser
         // 辅助变量
         signatoryMobile: '', // 个人联系
         BusinessLicenseNo: '', // 营业执照号
         openUserTab: false, // false/true打开弹窗
         signatoryIdentityCard: '', // 证件号
         canSelectArray: [], //  新增集团账户 数组
         canSelectArrayIndex: 0,
         ischange: 0, // 0/1是否修改
         notRegister: false, // 签署方是否注册
         disabled: false, // disabled是否禁止填写
         isEncrypt: false, // false/true是否加密(通过查询的加密)
         corpUser: '', // 企业联系, 如果是集团账户 存 corpUser
         * */
      signers: [],

      // 签署方身份信息验证相关 start
      //..... 验证用户输入的企业是否存在 start.....
      entCreditJson: null,
      entCreditArr: [],
      entNameArr: [],
      visibleCredit: false,
      //..... 验证用户输入的企业是否存在 end.....
      userIdentityInfoArr: [], // 存放需要进行姓名身份证二要素的数组
      // 签署方身份信息验证相关 end

      // 离开页面是否修改的判断
      highAuthorityPath: ["/advancedVersion/setVariable"], // 不需要判断可以直接跳转的路由
      sureEdit: false,
      tipsDialogVisible: false,
      toPath: "", // 拦截前用户想要前往的页面
      // 第二步
      department: [] // 部门列表
    };
  },
  beforeRouteEnter(to, from, next) {
    if (from.path !== "/advancedVersion/setVariable") {
      // 不是下一步设置变量过来的页面，都需要清空store
      getStore()
        .dispatch("advancedVersionState/clearAddTpl")
        .then(() => {
          next();
        });
    } else {
      next();
    }
  },
  created() {
    console.log(
      "advancedVersionModule数据",
      this.GET_addTpl_contractInfoJson,
      11111
    );
    let v = this.$store.getters.currentAuthUser;
    if (v && v.corpUserId) {
      this.isGroup = true;
      this.activeTabOrganizationName = v.corpName;
    }

    if (
      this.GET_addTpl_contractInfoJson &&
      JSON.stringify(this.GET_addTpl_contractInfoJson) !== "{}"
    ) {
      // 验证数据是否存在
      // 数据回显
      this.storeDataToPageData();
      // 渲染模板授权范围树状图数据
      // this.initTreeGroup();
    } else {
      // 初始新增或编辑
      getStore()
        .dispatch("advancedVersionState/clearAddTpl")
        .then(() => {
          this.getTemplateDetailByID();
        });
    }
  },
  mounted() {
    window.addEventListener("beforeunload", this.leavePage);
    if (this.isGroup) {
      this.queryToolMyCorp();
      this.getDpartmentList();
    }
  },
  beforeDestroy(next) {
    window.removeEventListener("beforeunload", this.leavePage);
  },
  // 页面路由更改时
  beforeRouteLeave(to, from, next) {
    if (this.canLeave(to.path)) {
      this.toPath = to.fullPath;
      this.tipsDialogVisible = true;
      next(false);
    } else {
      next(true);
    }
  },
  computed: {
    // 获取store里面的数据
    ...mapGetters("advancedVersionState", {
      GET_addTpl_recordContract: "GET_addTpl_recordContract",
      GET_addTpl_contractInfoJson: "GET_addTpl_contractInfoJson"
    })
  },
  methods: {
    // 获取文件后缀
    fileSuffix(fileName) {
      let first = fileName.lastIndexOf("."); //取到文件名开始到最后一个点的长度
      let namelength = fileName.length; //取到文件名长度
      let filesuffix = fileName.substring(first + 1, namelength); //截取获得后缀名
      return filesuffix;
    },
    validContractName: function() {
      if (this.contractInfo.tplName.length > 100) {
        return this.$message.warning("模板名称不能超过100个字符");
      }
    },
    loadingStart(info = null) {
      this.loading = this.$loading({
        lock: true,
        text: info || "正在拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, .5)"
      });
    },
    loadingClose() {
      if (this.loading) {
        this.loading.close();
        this.loading = null;
      }
    },
    // 业务逻辑

    // *********************第一步 start*************************
    // 获取组件列表信息
    getInputsInfo() {
      let stData = this.contractInfo;
      stData = stData && stData.inputGroups ? stData.inputGroups[0].inputs : [];
      return stData;
    },

    // ......离开页面判断 start.....
    // 刷新或者关闭页面时提示
    leavePage(e) {
      if (this.canLeave()) {
        let dialogText = "当前内容还未保存，确认退出编辑？"; // 大部分浏览器使用默认文案，这将不生效
        e = e || window.event;
        // For IE and Firefox prior to version 4
        if (e) {
          e.returnValue = dialogText;
        }
        // For Safari
        return dialogText;
      }
    },
    /// 确定退出
    confirmEdit() {
      this.tipsDialogVisible = false;
      this.sureEdit = true;
      this.$router.push({ path: this.toPath });
      // window.history.go(-2)
    },
    //
    /**
     * 是否可以离开页面
     * @toPath 页面要前往的地址
     * */
    canLeave(toPath) {
      return (
        this.highAuthorityPath.indexOf(toPath) === -1 &&
        !this.sureEdit &&
        this.IsPageChange()
      );
    },
    // 页面内容是否更改
    IsPageChange() {
      if (
        md5(JSON.stringify(this.GET_addTpl_recordContract)) !==
        md5(JSON.stringify(this.savedContractInfo()))
      ) {
        // 数据有更改
        return true;
      }
      return false;
    },
    /**
     * 用于存储比较用的setAddTplRecordContract信息,初次新增或者初次编辑时存储,过滤出必要的参数信息
     * 使用场景:离开页面时判断页面是否修改
     * */
    savedContractInfo() {
      return formatParam({
        tplId: this.contractInfo.tplId,
        tplName: this.contractInfo.tplName,
        orderFlag: this.contractInfo.orderFlag,
        inputGroups: this.contractInfo.inputGroups,
        signers: this.signers,
        // 文件上传信息
        files: [{ ...this.contractFile }, ...this.enclosureFiles],
        groupIdSet: this.selectNodes // 授权多个部门 id
      });
    },
    // ......离开页面判断 end......

    // 。。。。。。。。。。。进入页面时候的数据回显 start。。。。。。。。。。。。。。。
    // 页面初始化时：当store有数据时数据回显store里面的数据
    storeDataToPageData() {
      // store里面的数据转换为当前需要的页面数据
      // 新增时上一步回到当前页面的回显
      let savedInfo = this.GET_addTpl_contractInfoJson; // 获取存储的变量完整信息

      this.contractInfo = savedInfo;
      // 合同信息
      this.contractFile = savedInfo.files.find(item => item.tplFileType == 1); // 1合同，2附件
      // 附件信息
      this.enclosureFiles =
        savedInfo.files.length > 1
          ? savedInfo.files.filter(item => item.tplFileType == 2)
          : [];
      // 签署方信息

      this.signers = savedInfo.signers;
      console.log("signers:", this.signers);
      // 模板授权范围
      this.selectNodes = savedInfo.groupIdSet;
    },
    /**
     *  初始进入编辑页面时，获取构造页面显示的数据
     *  @resultData 根据模板id查询并返回的模板详情数据
     * */
    editDataToPageData(data) {
      let context = data.context;
      this.contractInfo = {
        tplId: data.tplId,
        tplName: data.tplName,
        signers: context.signers, // 签署方
        files: context.files, // 文件上传信息
        orderFlag: context.orderFlag, // 是否顺序签字
        inputGroups: context.inputGroups, // 组件列表
        groupIdSet: data.groupList // 授权多个部门 id
      };

      // 合同信息
      this.contractFile = this.contractInfo.files.find(
        item => item.tplFileType == 1
      ); // 1合同，2附件
      // 附件信息
      this.enclosureFiles =
        this.contractInfo.files.length > 1
          ? this.contractInfo.files.filter(item => item.tplFileType == 2)
          : [];

      // **************签署方信息 start***********

      this.signers = JSON.parse(JSON.stringify(this.contractInfo.signers)).map(
        item => {
          return {
            ...item,
            authLevel: +item.authLevel || null,
            // 辅助变量
            signatoryMobile: "", // 个人联系
            BusinessLicenseNo: "", // 营业执照号
            openUserTab: false, // false/true打开弹窗
            signatoryIdentityCard: item.identityNo, // 证件号
            canSelectArray: [], //  新增集团账户 数组
            canSelectArrayIndex: 0,
            ischange: 0, // 0/1是否修改
            notRegister: false, // 签署方是否注册
            disabled: "disabled", // disabled是否禁止填写
            isEncrypt: false, // false/true是否加密(通过查询的加密)
            corpUser: "" // 企业联系, 如果是集团账户 存 corpUser
          };
        }
      );
      // 组装signers 这里涉及多个前端辅助变量
      this.signers.map((item, index) => {
        if (item.emailOrMobile) {
          postFindByEmailOrMphon({targetId:item.emailOrMobile}).then(data => {
            if (data.data && data.data.length) {
              let canSelectArray = data.data;
              let v = canSelectArray.find(sub => sub.name === item.name);
              item.canSelectArray = canSelectArray;
              item.canSelectArrayIndex = canSelectArray.findIndex(
                sub => sub.name === item.name
              );

              if (item.userType === 1) {
                // 企业
                item.BusinessLicenseNo = v.businessLicense;
                item.corpUser = v.corpUser;
                item.signatoryMobile = "";
                item.ischange = 1;
                item.disabled = "disabled";
              } else {
                item.corpUser = "";
                item.signatoryMobile = item.emailOrMobile;
                item.ischange = 1;
                item.disabled = "disabled";
              }
            } else {
              item.canSelectArray = [];
              item.disabled = "disabled";
              item.corpUser = "";
              item.ischange = 1;
              item.signatoryMobile = "";
            }
          });
        } else {
          item.disabled = false;
        }
      });

      // **************签署方信息 end***********

      // 模板授权范围
      this.selectNodes = this.contractInfo.groupIdSet;

      // 渲染模板授权范围树状图数据
      // this.initTreeGroup();

      // 修改时初次进入存储信息-用于比较判断是否修改
      this.$store.dispatch(
        "advancedVersionState/setAddTplRecordContract",
        this.savedContractInfo()
      );
    },
    // 。。。。。。。。。。。进入页面时候的数据回显 end。。。。。。。。。。。。。。。

    // 下一步操作时，离开页面：将当前需要的页面数据转换为store里面的存储数据
    pageDataToStoreData(callback) {
      // 将信息存储到store
      this.$store
        .dispatch("advancedVersionState/SETAddTplContractInfoJson", {
          ...this.contractInfo,
          signers: this.signers,
          // 文件上传信息
          files: [{ ...this.contractFile }, ...this.enclosureFiles],
          groupIdSet: this.selectNodes // 授权多个部门 id
        })
        .then(() => {
          callback && callback();
        });
    },
    /**
     *  获取模板详情
     * */
    getTemplateDetailByID() {
      return new Promise((resolve, reject) => {
        const { userType, id } = this.$route.query;
        if (id) {
          const typeBool =
            userType == 0
              ? ApiMethods.TemplateController.personDetailByID
              : ApiMethods.TemplateController.advanceVDetailByID;
          // 修改
          typeBool(id).then(result => {
            if (!result.success)
              return this.$message.error(result.description || this.$tip);
            this.editDataToPageData(result.data);
            this.$store.commit(
              "advancedVersionState/SET_addTpl_tplData",
              result.data
            );
            resolve();
          });
        } else {
          // 新增
          // 默认显示一个签署方
          this.addSignerList(0);
          // 新增初次进入存储信息-用于比较判断是否修改
          this.$store.dispatch(
            "advancedVersionState/setAddTplRecordContract",
            this.savedContractInfo()
          );
          // 异步接口请求放后面-依赖于上面设置的初值
          // this.initTreeGroup();
          resolve();
        }
      });
    },
    // 。。。。。。。。。。。。文件上传相关 start。。。。。。
    // 合同上传
    contractFileUpload(e) {
      let file = e.target.files[0] || e.value;
      const filename_arry = file.name.split(".");
      filename_arry.splice(filename_arry.length - 1, 1);
      let fileName = filename_arry.join(".");
      // let re = new RegExp('(.jpg|.png|.bmp|.jpeg|.pdf|.doc|.docx)$', 'i');
      let re = new RegExp("(.pdf|.doc|.docx)$", "i");

      if (!re.test(file.name)) {
        e.target.value = "";
        // return this.$message.warning('文件格式只能是jpg/png/bmp/pdf/doc/docx的文件');
        return this.$message.warning("文件格式只能是pdf/doc/docx的文件");
      }

      if (file.size > 1024 * 1024 * 20) {
        e.target.value = "";
        return this.$message.warning("文件大小不能超过20M");
      }

      this.loadingStart();
      uploadFileAndConvertInfo({ file: file, fileType: 1, fileName: fileName })
        .then(data => {
          e.target.value = "";
          this.loadingClose();
          console.log("上传合同：", data);
          this.contractFile = {
            fileName: file.name,
            tplFileType: 1, // 文件类型：1合同文件 2附件
            tempFile: data.tempFile
            // "tempFile": { // 文件上传信息
            //   "sign": data.sign,
            //   "targetId": data.targetId,
            //   "ts": data.ts
            // },
          };

          !this.contractInfo.tplName && (this.contractInfo.tplName = fileName);
        })
        .catch(err => {
          e.target.value = "";
          this.loadingClose();
          this.$message.warning(err.description || "上传合同失败");
        });
    },
    // 重新上传合同
    reUpload() {
      let stData = this.getInputsInfo();
      if (stData && stData.length > 0) {
        this.$confirm("重新上传将清空已添加的变量，确定重新上传？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.contractInfo.inputGroups = [{ title: "", inputs: [] }];
            this.$refs["contractFileInput"].click();
          })
          .catch(() => {});
      } else {
        this.$refs["contractFileInput"].click();
      }
    },
    // 上传附件
    handleAttatchFileUpload(el) {
      if (this.enclosureFiles.length >= 3) {
        this.$message.error("附件最多只能上传3个");
        return (el.target.value = "");
      }
      el = el.target;
      let file = el.files[0] || null;
      if (!file) return false;
      if (file.size > 30 * 1024 * 1024) {
        this.$message.warning("附件大小不能超过30M!");
        return;
      }
      this.loadingStart("正在上传附件");
      postFileTempUpload2({ file: file, fileType: 1 })
        .then(data => {
          this.loadingClose();
          console.log("上传附件：", data);
          el.value = "";

          this.enclosureFiles.push({
            fileName: file.name,
            tplFileType: 2, // 文件类型：1合同文件 2附件
            tempFile: {
              // 文件上传信息
              fileType: data.fileType,
              sign: data.sign,
              targetId: data.targetId,
              ts: data.ts
            },
            // 前端辅助变量-文件大小
            size: file.size
          });
        })
        .catch(err => {
          this.loadingClose();
          el.value = "";
          this.$message.warning(err.description || "附件上传失败请重试");
        });
    },
    // 删除附件
    delAttatch(item, index) {
      this.enclosureFiles &&
        this.enclosureFiles.length &&
        this.enclosureFiles.splice(index, 1);
    },
    // 。。。。。。。。。。。。文件上传相关 end。。。。。。
    // 授权范围
    getCheckedNodes() {
      this.visibleMoveOrg = false;
      let selectedNodesAll = this.$refs.referenceMoveTree.getCheckedNodes();
      // this.selectNodes = this.getSelectRootNodes((selectedNodesAll));
      this.selectNodes = selectedNodesAll;
      console.log(this.selectNodes);
    },
    // 删除节点
    delNode(item) {
      this.selectNodes = this.selectNodes.filter(
        sub => sub.corpGroupId !== item.corpGroupId
      );
    },
    // 渲染模板授权范围树状图
    initTreeGroup() {
      let params = {};
      params.permId = 6;
      ApiCorpMethods.OrganizationController.treeGroup(params)
        .then(res => {
          if (+res.code == 0) {
            let treeGroup = this.convertFormateTree(res.data);
            this.treeGroupCopy = JSON.parse(JSON.stringify(treeGroup));
            // 页面回显设置的授权范围
            if (this.selectNodes && this.selectNodes.length > 0) {
              let arr = this.$utils.spreadTreeData(this.treeGroupCopy);
              this.selectNodes = this.selectNodes.map(item => {
                return {
                  ...item,
                  ...arr.find(sub => sub.corpGroupId === item.corpGroupId)
                };
              });
            }
          } else {
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.$message({ type: "error", message: error.description });
        });
    },
    /**
     *  设置选中节点
     * */
    setTreeCheckedNodes() {
      this.visibleMoveOrg = true;
      this.$nextTick(() => {
        this.$refs.referenceMoveTree &&
          this.$refs.referenceMoveTree.setCheckedNodes(this.selectNodes);
      });
    },
    /**
     *  筛选选中节点的父节点
     *  @nodes 选中的节点，包含父节点和字节点
     *  @return 返回过滤掉字节点
     * */
    getSelectRootNodes(nodes) {
      let nodesCopy = JSON.parse(JSON.stringify(nodes));
      // 删除字节点
      let deleteNode = function(item) {
        let inx = nodesCopy.findIndex(
          level1 => level1.parentId === item.corpGroupId
        );
        if (inx > -1) {
          nodesCopy.splice(inx, 1);
          deleteNode(item);
        }
      };
      // 递归过滤子节点
      let fn = function(currentItem) {
        deleteNode(currentItem);
        if (currentItem.childCorpGroups && currentItem.childCorpGroups.length) {
          currentItem.childCorpGroups.map(item => {
            fn(item);
          });
        }
      };
      // 遍历并过滤一级节点
      for (let i = 0; i < nodes.length; i++) {
        let item = nodes[i];
        deleteNode(item);
        item.childCorpGroups && item.childCorpGroups.length && fn(item);
      }
      return nodesCopy;
    },
    // 转换成tree需要的数据格式
    convertFormateTree(data) {
      data.forEach(element => {
        element.label = element.groupName + "(" + element.totalNum + "人)";
        if (element.childCorpGroups) {
          this.recursionChildren(element.childCorpGroups);
        }
      });
      return data;
    },
    recursionChildren(childCorpGroups) {
      childCorpGroups.forEach(element => {
        element.label = element.groupName + "(" + element.totalNum + "人)";
        if (element.childCorpGroups) {
          this.recursionChildren(element.childCorpGroups);
        }
      });
    },
    // *******************常用联系人start**********************
    // 另外一边打开通讯录
    handleTelsClickOther: function(item, index) {
      item.openUserTab = true;
      this.selectIndex = index;
      this.getTelList();
      this.showTel = true;
      // 清空集团账户选择人列表
      this.myCorpModel.keyword = "";
      this.clickHandleMyCorpSearch();
      // return openUserTab to true
      if (this.signers[this.selectIndex]) {
        this.signers[this.selectIndex].openUserTab = true;
      }
    },
    // 查询我的组织 签署人列表
    queryToolMyCorp() {
      this.myCorpModel.loading = true;
      this.tableAuditAndCopySelectRow = undefined;
      // if (this.myCorpModel.keyword) {
      this.myCorpModel.targetId = this.myCorpModel.keyword;
      ApiCorpMethods.CorpCommonController.listCorpUser(this.myCorpModel)
        .then(res => {
          this.myCorpModel.loading = false;
          if (res.code === "0") {
            this.tableListMyCorp = res.data;
            this.myCorpModel.total = res.total;
            if (res.total === 0) {
              this.myCorpModel.emptyText = "暂无数据";
            }
          } else {
            this.tableListMyCorp = [];
            this.myCorpModel.total = 0;
            this.myCorpModel.emptyText = res.description;
            this.$message.error(res.description);
          }
        })
        .catch(error => {
          this.myCorpModel.loading = false;
          this.tableListMyCorp = [];
          this.myCorpModel.total = 0;
          this.myCorpModel.emptyText = res.description;
          this.$message.error(err.description);
        });
      // } else {
      //   this.myCorpModel.loading = false;
      //   this.tableListMyCorp = [];
      //   this.myCorpModel.total = 0;
      //   this.myCorpModel.emptyText = '请输入组织内部签署方名称或账号';
      // }
    },
    // 我的组织 查询签署人
    clickHandleMyCorpSearch() {
      this.queryToolMyCorp();
    },
    // 获取最近联系人
    getTelList() {
      postTelFindByPagedEnterpriseList(this.telPageInfo)
        .then(data => {
          this.telList = data.data;
          this.telPageInfo.itemPage = data.pageNum;
          this.telPageInfo.pageSize = data.pageSize;
          this.telPageInfo.total = data.total;
        })
        .catch(err => {});
    },
    // 获取我的组织部门列表
    getDpartmentList() {
      ApiCorpMethods.CorpCommonController.listGroup().then(res => {
        if (res.success) {
          this.department = res.data;
        }
      });
    },
    // 选择通讯录和我的组织里面的人 确认按钮事件
    handleClickSelectSignorOk() {
      if (this.activeTabSigner === "organization") {
        this.tableSignorSelectRow = undefined;
      }

      if (
        this.$refs["contractListTab"] &&
        this.$refs["contractListTab"][this.selectIndex]
      ) {
        this.$refs["contractListTab"][this.selectIndex].clearValidate();
      } else {
        if (
          this.$refs["referenceSignerForm"] &&
          this.$refs["referenceSignerForm"].length > 0
        ) {
          this.$refs["referenceSignerForm"][this.selectIndex].clearValidate();
        }
      }

      // 复制以前的代码 怕报错
      /*********************************** */
      this.showTel = false;
      this.telPageInfo.accountNo = null;
      this.telPageInfo.name = null;
      this.telPageInfo.idNo = null;
      this.telPageInfo.itemPage = 1;
      // return openUserTab to false
      if (this.signers[this.selectIndex]) {
        this.signers[
          this.selectIndex
        ].emailOrMobile = this.tableSignorSelectRowTargetID;
        // this.signers[this.selectIndex].openUserTab = false
      }

      /*********************************** */
      this.getUserInfoBySelectTargetId(
        this.tableSignorSelectRowTargetID,
        this.selectIndex
      );
    },
    // 通讯录点击选中一行
    handleTelRowClickSelectRow(row, event, column) {
      if (row) {
        this.tableSignorSelectRow = row;
        this.tableSignorSelectRowTargetID = row.mobileOrChild;
      } else {
        this.tableSignorSelectRow = undefined;
        this.tableSignorSelectRowTargetID = "";
      }
    },
    handleSizeChange(val) {
      this.telPageInfo.itemPage = 1;
      this.telPageInfo.pageSize = val;
      this.getTelList();
    },
    handleCurrentChange(val) {
      this.telPageInfo.itemPage = val;
      this.getTelList();
    },

    // 我的组织 选择签署人 点击事件
    handleRowClickMyCorp(row, event, column) {
      if (row) {
        this.tableSignorSelectRowTargetID = row.targetId;
      } else {
        this.tableSignorSelectRowTargetID = "";
      }
    },

    handleSizeChangeQueryToolMyCorp(val) {
      this.myCorpModel.itemPage = 1;
      this.myCorpModel.pageSize = val;
      this.queryToolMyCorp();
    },
    handleCurrentChangeQueryToolMyCorp(val) {
      this.myCorpModel.itemPage = val;
      this.queryToolMyCorp();
    },
    // 根据用户从table选择的签署人查询信息
    getUserInfoBySelectTargetId(emailOrMobile, selectIndex) {
      if (selectIndex !== undefined) {
        this.selectIndex = selectIndex;
      }
      // 清空验证信息
      if (
        this.$refs["contractListTab"] &&
        this.$refs["contractListTab"][this.selectIndex]
      ) {
        this.$refs["contractListTab"][this.selectIndex].clearValidate();
      }

      if (emailOrMobile) {
        this.tableSignorSelectRowTargetID = emailOrMobile;
      }
      if (!emailOrMobile || !this.tableSignorSelectRowTargetID) {
        return;
      }
      let mobile = /^1[1-9]\d{9}$/;
      let email = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
      let targetId = this.tableSignorSelectRowTargetID;
      if (mobile.test(targetId) || email.test(targetId)) {
        postFindByEmailOrMphon({targetId}).then(data => {
          if (data.data) {
            this.fillSignorData(data.data);
          } else {
            this.fillSignorData([]);
          }
        });
      } else {
        this.fillSignorData([]);
      }
    },
    // *******************常用联系人end**********************
    /**
     * 添加签署方
     * @param fix 签署方key
     */
    addSignerList(fix = 1) {
      if (this.signers.length === 10) {
        return this.$message.warning("最多不能超过10个签署方");
      }
      this.signers.push({
        // 后端需要变量
        authLevel: 11, // 验证等极，默认勾选人脸
        emailOrMobile: "", // 手机或邮箱
        fix: fix, // "是否固定人员1是，0不是"
        identityNo: "", // 证件号
        name: "", // 名称
        signLevel: 0, // 签章等级
        signerAbc: signerDataList[this.signers.length].signerAbc, // 签署人abc标识
        userType: 0, // 用户类型 0个人 1企业
        corpUser: false, // 企业联系, 如果是集团账户 存 corpUser
        orderNum: 0,
        // 辅助变量
        signatoryMobile: "", // 个人联系
        BusinessLicenseNo: "", // 营业执照号
        openUserTab: false, // false/true打开弹窗
        signatoryIdentityCard: "", // 证件号
        canSelectArray: [], //  新增集团账户 数组
        canSelectArrayIndex: 0,
        ischange: 0, // 0/1是否修改
        notRegister: false, // 签署方是否注册
        disabled: false, // disabled是否禁止填写
        isEncrypt: false // false/true是否加密(通过查询的加密)
      });
    },
    // 删除签署方--比较特殊，删除时signerAbc值变化，需要实时更新组件对应的值，其他情况都在点击下一步操作时再更新
    delSigner(item, index) {
      console.log(item);
      if (!this.signers || !this.signers.length) return false;

      let inputs = this.getInputsInfo();

      let delQs = () => {
        // 将对应签署方的组件删除
        inputs = inputs.filter(sub => sub.signerAbc !== item.signerAbc);

        this.signers.splice(index, 1);

        // 重新分配签署方name，也就是签署方一，签署方二。。排序
        this.signers.map((sub, idx) => {
          let nameOld = sub.signerAbc;
          let nameNew = signerDataList[idx].signerAbc;
          inputs.map(sv => {
            if (sv.signerAbc === nameOld) {
              sv.signerAbc = nameNew;
            }
          });
          sub.signerAbc = nameNew;
        });

        this.contractInfo.inputGroups = [{ title: "", inputs: inputs }];
      };
      if (
        inputs.length &&
        inputs.find(sub => sub.signerAbc === item.signerAbc)
      ) {
        this.$confirm(`您已指定了该签署方的签章位置，确定删除？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            // 将对应签署方的组件删除
            delQs();
          })
          .catch(() => {});
      } else {
        delQs();
      }
    },
    // 是否需要人脸
    authLevelChange(e) {
      console.log(this.signers);
      // console.log(e,111111111)
      // if(!e) {
      //     this.authLevelShow = true
      // }
    },
    // 查询到结果后重新赋值
    fillSignorData(canSelectArray) {
      console.log(this.tableSignorSelectRow, 7777);
      let signor = undefined;
      this.signers.forEach((element, index) => {
        if (index === this.selectIndex) {
          signor = element;
        }
      });
      if (canSelectArray.length === 0) {
        // 按照以前老版本改
        if (this.tableSignorSelectRow) {
          // 有值
          // businessLicense: "155454526254523"	证件号
          // enterpriseName: "15545"	签署方名称
          // mobileOrChild: "13896918730"	联系方式
          let targetId = this.tableSignorSelectRow.mobileOrChild;
          let isPhone = false;
          if (/^\d{11}$/.test(targetId)) {
            isPhone = true;
          }

          signor.name = this.tableSignorSelectRow.enterpriseName;
          signor.signatoryIdentityCard = this.tableSignorSelectRow.businessLicense;
          let userType = isPhone ? 0 : 1;

          signor.identityNo =
            userType === 0 ? this.tableSignorSelectRow.businessLicense : "";
          signor.BusinessLicenseNo =
            userType === 0 ? "" : this.tableSignorSelectRow.businessLicense;

          signor.corpUser = "";
          signor.signatoryMobile = "";

          signor.userType = userType;
          if (signor.userType === 1) {
            signor.corpUser = targetId;
          } else {
            signor.signatoryMobile = targetId;
          }
          signor.ischange = 1;
          signor.disabled = "disabled";
          signor.signLevel = userType === 0 ? 1 : 2;
        } else {
          // 没有值
          // 下面这是清空的

          // name: 签署方名称, signatoryIdentityCard: 证件号, corpUser: 企业联系, signatoryMobile: 个人联系

          signor.name = "";
          signor.signatoryIdentityCard = "";
          signor.identityNo = "";
          signor.BusinessLicenseNo = "";
          signor.corpUser = "";
          signor.signatoryMobile = "";
          signor.userType = 0;

          signor.ischange = 0;
          signor.disabled = "";
          signor.signLevel = 0;
        }
      } else {
        let current = this.$store.getters.currentAuthUser;
        let corpId = "";
        if (current) {
          corpId = current.corpId;
        }
        // 默认选择第一个
        signor.canSelectArrayIndex = 0;
        canSelectArray.forEach((element, index) => {
          if (element.corpId && element.corpId === corpId) {
            signor.canSelectArrayIndex = index;
            signor.corpUser = true;
          }
        });

        let v = canSelectArray[signor.canSelectArrayIndex];
        signor.name = v.name;
        signor.signatoryIdentityCard = v.businessLicense || v.identityCard;
        signor.identityNo = v.userType === 0 ? v.identityCard : ""; // 个人信息
        signor.BusinessLicenseNo = v.userType === 0 ? "" : v.businessLicense; // 企业信息

        signor.corpUser = "";
        signor.signatoryMobile = "";

        signor.userType = v.userType;
        if (signor.userType === 1) {
          // 企业
          signor.corpUser = v.corpUser; // 存储企业联系
        } else {
          signor.signatoryMobile = signor.emailOrMobile; // 存储个人联系
        }
        signor.ischange = 1;
        signor.disabled = "disabled";
        if (signor.corpUser) {
          signor.signLevel = 0;
        } else {
          signor.signLevel = v.userType === 0 ? 1 : 2;
        }
      }
      this.signers.forEach((element, index) => {
        if (index === this.selectIndex) {
          signor.canSelectArray = canSelectArray;
          element = signor;
        }
      });
      this.tableSignorSelectRow = undefined;
    },
    // 联系方式改变，或点击修改btn
    handleTargetIdChange(sign) {
      sign.disabled = "";
      sign.isEncrypt = false;
      sign.ischange = 0;
      sign.notRegister = true;
      sign.identityNo = "";
      sign.signatoryIdentityCard = "";
      if (!sign.canSelectArray || sign.canSelectArray.length === 0) {
        sign.name = "";
      }
    },
    // 集团账户选择触发事件
    handleSelectCorpAccount(value, item) {
      let v = item.canSelectArray[value];
      if (v.corpUser) {
        item.corpUser = true;
        item.signLevel = 0;
      } else {
        item.corpUser = false;
        item.signLevel = v.userType === 0 ? 1 : 2;
      }

      item.signatoryMobile = "";
      item.corpUser = "";
      item.userType = v.userType;
      item.ischange = 1;
      item.disabled = "disabled";
      item.name = v.name;
      item.signatoryIdentityCard = v.businessLicense || v.identityCard;
      if (item.userType === 1) {
        item.BusinessLicenseNo = v.businessLicense;
        item.identityNo = "";
        item.corpUser = v.corpUser;
      } else {
        item.identityNo = v.identityCard;
        item.BusinessLicenseNo = "";
        item.signatoryMobile = item.emailOrMobile;
      }
    },
    // 处理用户类型选择
    handleSignUserType(signator) {
      signator.signatoryIdentityCard = "";
      signator.identityNo = "";
      signator.BusinessLicenseNo = "";
      if (signator.userType === 0) {
        signator.signatoryMobile = signator.corpUser;
        signator.corpUser = "";
        signator.signLevel = 1;
      } else {
        signator.corpUser = signator.signatoryMobile;
        signator.signatoryMobile = "";
        signator.signLevel = 2;
      }
    },
    // 是否固定签署方
    handleFixType(val, index) {
      this.signers = this.signers.map((item, idx) => {
        if (+index === idx) {
          if (+val === 0) {
            // 模板发起人指定,清空数据
            return {
              ...item,
              fix: val,
              // 后端需要变量
              emailOrMobile: "", // 手机或邮箱
              identityNo: "", // 证件号
              name: "", // 名称
              signLevel: 0, // 签章等级
              userType: 0, // 用户类型 0个人 1企业
              corpUser: false, // 企业联系, 如果是集团账户 存 corpUser
              orderNum: 0,
              // 辅助变量
              signatoryMobile: "", // 个人联系
              BusinessLicenseNo: "", // 营业执照号
              signatoryIdentityCard: "", // 证件号
              canSelectArray: [], //  新增集团账户 数组
              canSelectArrayIndex: 0,
              ischange: 0, // 0/1是否修改
              notRegister: false, // 签署方是否注册
              disabled: false, // disabled是否禁止填写
              isEncrypt: false // false/true是否加密(通过查询的加密)
            };
          } else {
            return {
              ...item,
              fix: val
            };
          }
        } else {
          return item;
        }
      });
    },

    // 保存成功并跳转
    savedAndLeave() {
      this.$store.dispatch("advancedVersionState/clearAddTpl").then(() => {
        // this.$router.push({path: '/console/setting', query: {activeName: 'tab-template'}})
        this.$router.push({
          path: "/console/template",
          query: { activeName: "mianSign" }
        });
      });
    },

    /**
     * WEB模版保存更新,修改
     * */
    saveTplData() {
      if (!this.contractInfo.tplName)
        return this.$message.warning("模板名称不能为空");

      this.sureEdit = true;

      let param = this.savedContractInfo();

      ApiMethods.TemplateController.advanceVOperTpl(param).then(result => {
        if (result.success) {
          // 保存草稿弹窗
          this.$message.success("保存成功");
          this.savedAndLeave();
        } else {
          this.$message.error(result.description || this.$tip);
        }
      });
    },
    /**
     *  存为草稿
     * */
    saveToDraft() {
      this.$confirm("确定保存为草稿？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.saveTplData();
        })
        .catch(() => {});
    },
    // *********************第一步 end*************************

    // *********************第二步 start*************************

    // 》》》》验证输入的企业是否存在,个人信息是否有误 相关操作 start《《《《

    // {name:identityNo} 姓名和身份证号组成的对象 说明：当二要素验证不通过时，用户确定使用当前填写的未通过验证数据，记录下来，下次不再提示 start
    getEysSaveInfo() {
      let info = sessionStorage.getItem("twoElementInfo");
      return info ? JSON.parse(info) : {};
    },
    setEysSaveInfo(obj = {}) {
      sessionStorage.setItem("twoElementInfo", JSON.stringify(obj));
    },
    // .....end

    // 手动输入证件号后提交合同
    addContractById() {
      this.visibleCredit = false;

      this.signers.forEach(t => {
        if (this.entCreditJson[t.name]) {
          t.signatoryIdentityCard = this.entCreditJson[t.name];
          // t.identityNo = this.entCreditJson[t.name];
        }
      });

      // 用户确定使用当前填写的未通过验证的二要素数据，记录下来，下次不再提示 start
      let sureIgnoreUserObj = this.getEysSaveInfo();
      this.userIdentityInfoArr.map(item => {
        sureIgnoreUserObj[item.name] = item.identityNo; // 覆盖之前的记录
      });
      this.setEysSaveInfo(sureIgnoreUserObj);
      this.userIdentityInfoArr = [];
      // .....end

      this.postSend();
    },
    // 取消合同发起或保存
    handleDelSendContract() {
      this.signers.forEach(t => {
        var entName = t.name;
        if (this.entNameArr.indexOf(entName) !== -1) {
          t.signatoryIdentityCard = "";
        }
      });
      this.entCreditArr = [];
      this.entCreditJson = {};
      this.entNameArr = [];
      this.userIdentityInfoArr = [];
      this.visibleCredit = false;
    },
    // 通过企业名称去查询企业的证件号
    queryEntIDByEntName(entNameArr) {
      this.entNameArr = entNameArr;
      this.loadingStart("正在认证签署人信息");
      return new Promise(async (resolve, reject) => {
        queryCreditCodeByEntName(entNameArr)
          .then(res => {
            this.loadingClose();
            if (res) {
              this.entCreditArr = [];
              this.entCreditJson = res;
              this.signers.forEach(t => {
                var entName = t.name;
                if (entNameArr.indexOf(entName) !== -1) {
                  if (res[entName]) {
                    t.signatoryIdentityCard = res[entName];
                  } else {
                    this.entCreditArr.push(entName);
                  }
                }
              });

              if (this.entCreditArr.length) {
                resolve({ sus: false }); // 显示签署方信息提示弹窗
              } else {
                resolve({ sus: true }); // 继续发起
              }
            } else {
              resolve({ sus: true }); // 继续发起
            }
          })
          .catch(err => {
            this.loadingClose();
            this.$message.error("合同发起失败请刷新后再试");
            console.log(
              "通过企业名称去查询企业的证件号： " + JSON.stringify(err)
            );
            reject(err);
          });
      }).catch(error => {
        return error;
      });
    },
    // 通过姓名身份证进行二要素验证
    twoElementsVerify(userInfoArr) {
      this.loadingStart("正在认证签署人信息");
      return new Promise(async (resolve, reject) => {
        queryUserValidateByNameIDnum(userInfoArr)
          .then(res => {
            this.loadingClose();
            if (res && res.length) {
              this.userIdentityInfoArr = res;
              resolve({ sus: false }); // 显示签署方信息提示弹窗
            } else {
              resolve({ sus: true }); // 继续发起
            }
          })
          .catch(err => {
            this.loadingClose();
            this.$message.error("合同发起失败请刷新后再试");
            console.log("身份证二要素验证： " + JSON.stringify(err));
            reject(err);
          });
      }).catch(error => {
        return error;
      });
    },

    // 》》》》验证输入的企业是否存在,个人信息是否有误 相关操作 end《《《《

    postSend() {
      this.pageDataToStoreData(() => {
        this.$router.push({
          path: "/advancedVersion/setVariable",
          query: { ...this.$route.query, userType: 0 }
        });
        // userType 0 个人 1 企业
      });
    },

    async nextStep() {
      console.log("signers:", this.signers);
      console.log("附件:", this.enclosureFiles);

      // 验证
      if (!this.contractFile.fileName) {
        return this.$message.warning("请上传模板文件");
      }

      // 验证模板名称
      let contFormValidate = await new Promise((resolve, reject) => {
        this.$refs["contForm"].validate(valid => {
          if (valid) {
            resolve(true);
          } else {
            resolve(false);
            console.log("error submit!!");
            return false;
          }
        });
      });

      // 验证批量签署方form表单列表
      let validChildBatch = true;
      let contractBatchListTab = this.$refs.contractListTab;
      if (contractBatchListTab) {
        contractBatchListTab.forEach(t => {
          t.validate(() => {});
        });
        try {
          contractBatchListTab.forEach(t => {
            const fields = t.fields;
            if (fields) {
              fields.forEach(element => {
                if (element.prop !== "" && element.validateState === "error") {
                  throw new Error("validFails");
                }
              });
            }
          });
        } catch (error) {
          validChildBatch = false;
        }
      }

      if (contFormValidate && validChildBatch) {
        // 验证 （1197 隐藏）
        // if (!this.selectNodes || !this.selectNodes.length) {
        //   return this.$message.warning("请选择模板授权范围");
        // }

        // 验证通过

        // 证件号合二为一 针对新用户
        let signatoryJsonCopy = JSON.parse(JSON.stringify(this.signers));
        signatoryJsonCopy.forEach(t => {
          if (!t.signatoryIdentityCard) {
            if (parseInt(t.userType) === 1) {
              t.signatoryIdentityCard = t.BusinessLicenseNo;
            } else {
              t.signatoryIdentityCard = t.identityNo;
            }
          }
          if (!t.corpUser && !t.signatoryMobile) {
            if (parseInt(t.userType) === 1) {
              t.corpUser = t.emailOrMobile;
            } else {
              t.signatoryMobile = t.emailOrMobile;
            }
          }
        });

        // 》》》》验证输入的企业是否存在,个人信息是否有误 相关操作 start《《《《
        // 签署方是企业用户且没有证件号
        this.entCreditJson = {};
        this.entCreditArr = [];
        this.entNameArr = [];
        var queryCreditcodeParam = [];
        // 二要素验证变量
        this.userIdentityInfoArr = [];
        let userIdentityInfoParam = []; // 存放需要进行二要素的数组
        signatoryJsonCopy.forEach(t => {
          // 企业用户且没有证件号
          if (
            parseInt(t.userType) === 1 &&
            t.name &&
            !t.signatoryIdentityCard
          ) {
            queryCreditcodeParam.push(t.name);
          }
          // 个人信息-姓名身份证二要素验证
          if (
            parseInt(t.userType) === 0 &&
            t.name &&
            t.signatoryIdentityCard &&
            t.signatoryIdentityCard.indexOf("***") === -1
          ) {
            // 是个人且有姓名身份证号码，且身份证号码未加密（手动输入的）

            let recordIdentityNo = this.getEysSaveInfo()[t.name];
            if (
              !recordIdentityNo ||
              recordIdentityNo !== t.signatoryIdentityCard
            ) {
              // 若之前记录有未通过二要素验证的数据（但用户已确认数据正确），且记录的数据和现在的值相同，则不再进行二要素验证
              userIdentityInfoParam.push({
                name: t.name,
                identityNo: t.signatoryIdentityCard
              });
            }
          }
        });

        if (
          (queryCreditcodeParam && queryCreditcodeParam.length) ||
          (userIdentityInfoParam && userIdentityInfoParam.length)
        ) {
          // 查询企业执照号，验证个人信息
          let arr = [];
          if (queryCreditcodeParam && queryCreditcodeParam.length) {
            // 查询企业执照号并将查询到的企业赋值
            arr.push(this.queryEntIDByEntName(queryCreditcodeParam));
          }
          if (userIdentityInfoParam && userIdentityInfoParam.length) {
            // 二要素验证，身份信息不正确的予以提示
            arr.push(this.twoElementsVerify(userIdentityInfoParam));
          }
          Promise.all(arr).then(res => {
            if (res && res.length) {
              for (let i = 0; i < res.length; i++) {
                let smt = res[i];
                if (smt && !smt.sus) {
                  this.visibleCredit = true; // 显示签署方信息提示弹窗
                  return false; // 中止后面的操作
                }
              }
              this.postSend(); // 信息无误
            }
          });
        } else {
          // 》》》》验证输入的企业是否存在,个人信息是否有误 相关操作 end《《《《
          this.postSend();
        }
      } else {
        console.log("验证不通过");
      }
    }
    // *********************第二步 end*************************
  },
  layout: "entconsolelayout",
  head: { title: "模板设置" }
};
</script>
<style scoped lang="less">
@import (less) "../../../assets/style/icon.css";

.font-elips() {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.wrap {
  max-width: 1200px;
  margin: 0 auto;
}

.tab {
  /*border: 1px dashed #dbdbdb;*/

  .list-box {
    /*padding: 15px 14px;*/
    padding: 10px 0;

    /*.sign-item {*/
    /*  &:hover {*/
    /*    background-color: #eee;*/
    /*    !*border: 1px solid #eee !important;*!*/
    /*  }*/
    /*}*/

    .i-drag:hover {
      background-color: #f8f8f8;
    }

    .i-drag:active {
      background-color: #fff2e6 !important;
    }

    .draging {
      background-color: #fff2e6;
    }

    .user-type {
      text-align: center;
      /*cursor: pointer;*/
      padding: 0 10px;

      p {
        text-align: center;
        line-height: 50px;
        white-space: nowrap;
        text-overflow: ellipsis;
        box-sizing: border-box;
      }

      i {
        display: inline-block;
        width: 34px;
        height: 32px;
        vertical-align: super;
      }
    }

    .item {
      /*border: 1px solid #fce7e7;*/
      /*margin: 15px;*/
      display: table;
      width: 100%;
      /*width: calc(100% - 30px);*/

      .col {
        /*overflow-x: hidden;*/
        white-space: nowrap;
        text-overflow: ellipsis;
        box-sizing: border-box;
        display: table-cell;
        /*padding-top:8px;*/
        margin-right: 10px;
        /*padding: 8px 20px 0 0;*/

        &:last-child {
          margin-right: 0;
          width: 200px;
          flex: none;
        }
      }
      /deep/ .el-checkbox__label {
        color: rgba(41, 2, 2, 0.45);
        font-size: 14px;
      }

      .final {
        /deep/ .el-form-item__content {
          justify-content: space-between;
          display: flex;
          align-items: center;
        }
      }
    }

    .icon-move_box {
      position: absolute;
      left: -5px;
      width: 15px;
      height: 15px;
      top: 50%;
      margin-top: -8px;
    }

    .icon-move_box i {
      background: url("../../../assets/images/move-icon-default.png") no-repeat
        center center;
      background-size: 100% 100%;
      width: 100%;
      height: 100%;
      /*border-right: 1px solid #fce7e7;*/
      display: block;
      /*width: 30px;*/
      /*height: 50px;*/
      /*line-height: 50px;*/
      color: #ec1c1c;
      text-align: center;
      font-size: 20px;
    }

    .icon-move_box i:hover {
      cursor: move;
      background: url("../../../assets/images/move-icon.png") no-repeat center
        center;
      background-size: 100% 100%;
    }

    li {
      margin: 10px 0 10px 10px;
      border-radius: 2px;
    }

    .col {
      display: inline-block !important;
      /deep/ .el-input__inner {
        color: #000000;
      }
    }
    .IDCard {
      /deep/ .el-input__inner {
        padding-right: 35px;
      }
    }
  }

  .radio {
    padding: 5px 14px;
    border-bottom: 1px dashed #dbdbdb;

    small {
      color: #999999;
      margin-left: 14px;
    }
  }
}

.cont-form {
  width: 100%;

  .amend-tab__form {
    display: inline-block;
    position: absolute;
    width: 30px;
    right: 0;
  }

  .el-radio.is-bordered.is-checked {
    border-color: #ec1c1c;
    color: #333333;
  }

  .checkbox {
    width: 100%;
    height: 80px;
    padding-top: 22px;

    &.end-time {
      box-sizing: border-box;
      width: 100%;
      height: 80px;
      padding: 10px;
      border: 1px solid #dcdfe6;
    }

    p.small {
      padding-left: 0px;
    }

    p.title {
      font-size: 12px;
      color: #666666 !important;
      font-weight: 600;

      i {
        box-sizing: border-box;
        color: #ec1c1c;
      }
    }

    p {
      color: #333333 !important;
      display: inline-block;
    }
  }

  div.h4,
  h4 {
    color: #290202;
    padding-top: 10px;
    line-height: 36px;
    font-size: 16px;
    margin: 0;
    font-weight: bold;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /*padding-left:15px;*/

    > i {
      display: inline-block;
      width: 5px;
      height: 15px;
      background: rgba(38, 38, 38, 1);
      opacity: 1;
      border-radius: 100px;
      margin-right: 10px;
      vertical-align: middle;
    }

    .more-set {
      line-height: 32px;
      font-size: 14px;
      margin-right: 20px;
      cursor: pointer;

      i {
        font-size: 26px;
        vertical-align: middle;
      }

      &.down i {
        animation: keyRotateToToDown 0.3s;
        transform: rotate(180deg);
      }

      &.up i {
        animation: keyRotateToUp 0.3s;
        transform: rotate(0deg);
      }

      &.down-noani i {
        transform: rotate(180deg);
      }

      &.up-noani i {
        transform: rotate(0deg);
      }
    }
  }

  /*20200526重置样式*/

  /deep/ .el-input__inner {
    height: 35px;
    line-height: 35px;
    padding-left: 10px;
  }

  .f-top {
    background-color: #ffffff;
    margin-bottom: 20px;

    .el-form-item {
      margin-bottom: 0;
    }

    .el-row {
      padding: 20px 30px 20px 20px;
    }
  }

  .f-center {
    .f-top();

    div.h4 {
      justify-content: space-between;
      flex-wrap: nowrap;

      .el-checkbox__label {
        /*color: #000000;*/
        font-weight: normal;

        b {
          font-weight: normal;
          /*color: #000000;*/
        }
      }

      small {
        color: rgba(0, 0, 0, 0.45);
        margin-left: 5px;
      }

      .more-set {
        color: rgba(0, 0, 0, 0.45);
      }
    }

    .wp {
      flex: auto;
      margin-left: 40px;
    }

    .radio {
      padding: 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
    }

    li .el-row {
      padding: 0;
    }
  }

  .f-center2 {
    .f-top();
  }

  .f-bottom {
    .f-top();
    margin-bottom: 100px;
  }

  .bow {
    padding: 20px;
  }

  .sign-item {
    display: flex !important;
    justify-content: space-between;
    align-items: center;
    position: relative;

    > div {
      /*flex: none;*/

      &:last-child {
        flex: auto;
        text-align: right;
      }
    }
  }

  .c-btn {
    min-width: 82px;
    line-height: 25px;
    padding: 0;
    font-size: 12px;
    text-align: center;
    border: 1px solid rgba(236, 28, 28, 1);
    border-radius: 2px;
    color: #ec1c1c;

    &:hover {
      background-color: gba(236, 28, 28, 1);
      color: #ffffff;
    }
  }

  .y-btn {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    border: none;
    padding: 0;
    color: #ec1c1c;
    background: transparent !important;

    &:hover {
      opacity: 0.5;
    }
  }

  .el-icon-delete {
    color: rgba(41, 2, 2, 0.45);
    cursor: pointer;
    font-size: 16px;
    &:hover {
      color: #ec1c1c;
    }
  }

  .s-er /deep/ .el-form-item__error {
    top: 74%;
    left: 20px;
  }
}

/*文件上传*/
.input-wrap {
  box-sizing: border-box;
  padding: 30px 30px;

  .input-box {
    width: 175px;
    height: 140px;
    border: 1px solid #dcdcdc;
    opacity: 1;
    border-radius: 4px;
    text-align: center;
    color: rgba(41, 2, 2, 0.45);
    position: relative;
    overflow: hidden;
    cursor: pointer;

    p {
      font-size: 12px;
      font-family: Source Han Sans SC;
      /*margin-top: 16px;*/
    }

    .el-icon-plus {
      margin-top: 20px;
      font-size: 60px;
    }

    input {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }

    img {
      display: block;
      margin: 0 auto;
    }

    .f-box {
      width: 100%;
      height: 100%;
      position: relative;
      overflow: hidden;
      z-index: 3;
      .msk {
        overflow: hidden;
        position: absolute;
        width: 0;
        height: 0;
        left: 0;
        top: 0;
        display: none;
        z-index: 3;
        transition: all ease-in 0.2s;
        background: rgba(0, 0, 0, 0.5);
        text-align: center;
        a {
          font-size: 14px;
          font-family: Source Han Sans SC;
          font-weight: bold;
          color: #ffffff;
          /*margin-top: 60px;*/
          cursor: pointer;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
        }
      }
      img {
        height: 48px;
        width: auto;
        margin-top: 28px;
      }
      .bx {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        bottom: 35px;
        z-index: 3;
        &:hover .msk {
          width: 100%;
          height: 140px;
          display: block;
        }
      }
      p {
        z-index: 1;
        position: absolute;
        left: 0;
        bottom: 0;
        .font-elips();
        padding: 0 10px;
        background: rgba(239, 239, 239, 1);
        text-align: center;
        height: 35px;
        width: 100%;
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #290202;
      }
    }
  }

  /*附件*/

  .fj-wrap {
    margin-top: 33px;
    color: rgba(41, 2, 2, 0.85);
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .fj {
      display: inline-block;
      /*width: 233px;*/
      width: 170px;
      height: 30px;
      background: #f8f8f8;
      border-radius: 2px;
      position: relative;
      padding-left: 5px;
      padding-right: 10px;
      box-sizing: border-box;
      font-size: 14px;
      font-family: Source Han Sans SC;
      color: rgba(41, 2, 2, 0.85);
      margin-right: 31px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &:last-of-type {
        margin-right: 0;
      }

      .text {
        display: inline-block;
        max-width: 154px;
        .font-elips();
      }

      .size {
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        line-height: 20px;
        color: rgba(41, 2, 2, 0.45);
        opacity: 1;
      }

      .el-icon-error {
        color: #a1a1a1;
        position: absolute;
        right: -6px;
        top: -6px;
        font-size: 16px;
        cursor: pointer;
        &:hover {
          color: rgba(236, 28, 28, 1);
        }
      }
    }

    .fj-box {
      position: relative;
      cursor: pointer;
      .icon-fj {
        cursor: pointer;
      }
      &:hover {
        color: rgba(236, 28, 28, 0.85);
        .icon-fj {
          .icon-fj-on();
        }
      }
      input {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        cursor: pointer;
      }
    }
  }
}

.row-con {
  padding: 25px 15px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.my-select {
  .font-elips();
  vertical-align: middle;
  position: relative;
  cursor: pointer;
  margin-left: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  min-width: 360px;
  max-width: 90%;
  box-sizing: border-box;
  min-height: 35px;
  line-height: 35px;
  border: 1px solid #dcdcdc;
  border-radius: 4px;
  box-sizing: border-box;
  color: #290202;
  text-align: left;
  padding-left: 10px;
  padding-right: 30px;
  flex-wrap: wrap;

  span {
    color: rgba(41, 2, 2, 0.45);
  }

  .tx {
    flex: none;
    .font-elips();
    color: inherit;
    display: inline-block;
    margin: 5px 5px 5px 0;
    padding-left: 5px;
    padding-right: 25px;
    position: relative;
    border-radius: 4px;
    background-color: #f4f4f5;
    box-sizing: border-box;
    vertical-align: middle;
    line-height: 25px;
    width: 100px;
    text-align: left;

    .el-icon-error {
      position: absolute;
      right: 5px;
      cursor: pointer;
      top: 50%;
      line-height: 100%;
      margin-top: -7px;
    }
  }

  .el-icon-arrow-down {
    position: absolute;
    right: 5px;
    top: 0;
    font-size: 14px;
    line-height: 35px;
  }
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #ec1c1c;
}

.abtn {
  line-height: 32px;
  padding: 0;
  width: 120px;
  text-align: center;
  /*font-size: 14px;*/
}
</style>
<style lang="less">
.tel-box {
  .el-table__row.current-row {
    color: #ec1c1c;
  }
}
</style>



// WEBPACK FOOTER //
// pages/tpl/add/addTpl.vue